<template>
     
        <div class="video-bg">
            <div class="video-overlay">
                <video id="background-video" autoplay loop muted preload="auto">
                    <source src="img/sliders/slider.mp4" type="video/mp4">
                </video>
            </div>
           
                <div style="width: 100%;">
                    <div class="row navigator_row" style="">
                        <div class="col-12 col-lg-8 navigator">
                             <!-- BUTTONS -->

          

            <div class="home-content" style="padding: 0em 0 0 1.5em;">
                <!-- Titles -->
                <!-- <h1 class="text-weight-thin text-white">Data Navigator</h1> -->
                <h1>DATA NAVIGATOR </h1>
                <h2 class="title">Explore Bayer's Women's Healthcare <br/>products and trials <br /></h2>
                   <ul class="home-links">
                <li>
                    <router-link to="/disease-state" @click.native="trackEvent" class="btn btn-primary btn-chevron-right"
                        data-category="navigation" data-action="button_press" data-event="Explore by disease state">Explore
                        by disease state</router-link>
                </li>
                <li>
                    <router-link to="/select-product" @click.native="trackEvent" class="btn btn-primary btn-chevron-right"
                        data-category="navigation" data-action="button_press" data-event="Explore by product">Explore by
                        product</router-link>
                </li>
                <li>
                    <router-link to="/timeline" @click.native="trackEvent" class="btn bg-white btn-chevron-right btn-chevron-right-green"
                        data-category="navigation" data-action="button_press" data-event="See all">See all</router-link>
                </li>
            </ul>
            </div>

            <!-- Buttons -->
        
               
                             <!-- END BUTTONS -->
                        </div>

                    </div>
                    
                </div>
              
            
        </div>
</template>

<script>

export default {
    name: "Slider",
    components: {},
    data() {
        return {}
    },
    created: function () {

    },
    methods: {
        trackEvent: function (event) {
            this.analytics.trackEvent(this.$router.currentRoute.path, 'navigation', event.target);
        }
    }
}

</script>

<style scoped>
.visually-hidden {
    /* https://snook.ca/archives/html_and_css/hiding-content-for-accessibility */
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px 1px 1px 1px);
    /* IE6, IE7 */
    clip: rect(1px, 1px, 1px, 1px);
}

.home-content h1 {
    font-size: 5.5em;
}

.home-content h2 {
    font-size: 1.5em;
    color: #003B33;
}
@media only screen and (max-width:767px){
   .home-content h1 {
    font-size: 3.5em;
} 
.home-content h2 {
    font-size:20px;
}
}
.strong {
    font-weight: bold;
}

.homepage-disclaimer {
    width: 360px;
    max-width: 35%;
    font-size: 0.75em;
    line-height: 1.2em;
    color: white;
}

@media (min-width: 1920px) {
    .homepage-disclaimer {
        width: 434px;
    }
}
</style>